import { ICredit } from "./interfaces";

export const caseInsensitiveSort = (rowA: any, rowB: any) => {
  const a = rowA.title;
  const b = rowB.title;

  if (a > b) {
    return 1;
  }

  if (b > a) {
    return -1;
  }

  return 0;
}

export function handleProvince(acronym: string) {
  // This would need to be imported from a constants file or passed as parameter
  // For now, we'll create a placeholder
  const provinceConstants = [
    { acronym: 'SP', value: 'São Paulo' },
    { acronym: 'RJ', value: 'Rio de Janeiro' },
    // Add more as needed
  ];

  const result = provinceConstants.find(obj => obj.acronym === acronym);
  return result ? result.value.toString() : null;
}

export function handleAssessmentStatus(status: string, error: boolean = false) {
  if (error) {
    return 'analyst.assesments_status_error'
  }
  switch (status) {
    case 'waiting':
      return 'analyst.assesments_status_awaiting'
    case 'done':
      return 'analyst.assesments_status_done'
    case 'generated':
      return 'analyst.assesments_status_generated'
    default:
      return null
  }
}

export function handleAssessmentTag(status: string) {
  switch (status) {
    case 'analyst.assesments_status_awaiting':
      return 'yellow'
    case 'analyst.assesments_status_done':
      return 'green'
    case 'analyst.assesments_status_generated':
      return 'blue'
    case 'analyst.assesments_status_error':
      return 'red'
    default:
      return null
  }
}

export function handleReportType(id: number) {
  switch (id) {
    case 1:
      return 'general.simple_assessment'
    case 2:
      return 'general.extended_assessment'
    default:
      return null
  }
}

export function base64(img: string) {
  return `data:image/png;base64, ${img}`
}

export function openUrl(key: string, constructUrl: boolean = false) {
  const url = constructUrl ? `https://bemap.sfo3.cdn.digitaloceanspaces.com/${key}` : key;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    window.location.href = url;
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export const getActiveSubsystem = (pathname: string): string => {
  if (pathname.startsWith('/admin')) return 'admin';
  if (pathname.startsWith('/assessments')) return 'assessments';
  if (pathname.startsWith('/crm')) return 'crm';
  if (pathname.startsWith('/university')) return 'university';
  return '404';
};

export function calculateTotalCredits(credits: ICredit[]) {
  return credits.reduce((total, entry) => {
    if (entry.type === "transfer" || entry.type === "add") {
      return total + entry.amount;
    } else if (entry.type === "use") {
      return total - entry.amount;
    }
    return total;
  }, 0);
}

export const getConsumptionType = (history: ICredit) => {
  if (history.to_assessment_id) {
    return "general.consumption_type.assessment";
  } else if (history.from_team_id) {
    return "general.consumption_type.transfer";
  }
  return null;
}